import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';

//Components
import TextField from '../../../../components/TextField/TextField';
import Loading from '../../../../components/Loading/Loading';

//Helpers
import { validarCampos, PrintValidate } from '../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../helpers/mascaras';
import { showMessage } from '../../../../helpers/message';

//Api
import usuario_api from '../../../../api/usuario_api';
import setor_api from '../../../../api/setor_api';

//Shared
import FiltroPrefeitura from '../../../Shared/FiltroPrefeitura';

//Context
import { useAuth } from '../../../../context/auth';

export default function FormularioUsuario({ usuario, setUsuario, campos, errorsParam = {} }) {
    //Context
    const { session } = useAuth();

    //Controle dos erros no formulario
    const [errors, setErrors] = useState(errorsParam);

    //Estado de controle das opções de setores
    const [regionais, setRegionais] = useState([]);

    //Controla o loading na tela
    const [loading, setLoading] = useState(false);

    //Seta os erros de acordo com o valor dos erros que vem como paramentro 
    useEffect(() => {
        setErrors(errorsParam);
    }, [errorsParam]);

    //onChange para o campo de regional
    const onChangeRegional = (e, select) => {
        const { name } = select;
        setUsuario({
            ...usuario,
            [name]: e,
        })
    }
    //Change para os campos do formulario do usuario
    const onChangeUsuario = (e) => {
        const { name, value } = e.target;
        const _usuario = {
            ...usuario,
            [name]: value
        }
        const campo = campos.filter(c => c.name === name);
        const erro = validarCampos(_usuario, campo);
        if (erro[1].length === 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erro[0] });
        }
        setUsuario(_usuario);
    }

    //Função que carrega o usuario pelo cpf cnpj
    const loadUsuarioByCPFCNPJ = (e) => {
        const { name, value } = e.target;
        if (value.length == 11 || value.length == 14) {
            setLoading(true);
            usuario_api.getItemByCPFCNPJ(value).then(response => {
                if (response.data) {
                    if ((session.perfil != "Fiscal" || session.perfil != "Gestor" || session.perfil != "Master") &&
                        response.data.perfil == "Administrativo" &&
                        session.perfil == "Administrativo" &&
                        response.data.nome == session.nome) {
                        showMessage("Aviso!", "O CPF/CNPJ informado pertence ao cadastro principal do sistema e não pode ser alterado!", "warning", null);
                        setUsuario({
                            ...usuario,
                            ["cpfcnpj"]: ""
                        });
                        return;
                    }

                    setUsuario(response.data);
                }

            })
                .catch(e => showMessage("Aviso!", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    //Opções para o select de status do usuario
    const optionsStatus = [
        { text: "Ativo", value: "Ativo" },
        { text: "Bloqueado", value: "Bloqueado" },
        { text: "Cancelado", value: "Cancelado" },
        { text: "Inativo", value: "Inativo" },
    ]

    //Opções para o select de perfil do usuario
    const [optionsPerfil, set_optionsPerfil] = useState([]);
    const loadOptionsPerfil = () => {
        setLoading(true);
        usuario_api.getPerfisCadastro().then(response => {
            let _perfis = [{ text: "Selecione", value: null }];
            response.data.map(m => {
                _perfis.push({ text: m, value: m });
            })
            set_optionsPerfil(_perfis);
        }).catch(e => {
            showMessage("Aviso", e.message, "error");
        }).finally(f => setLoading(false));
    }
    const loadOptionsSetores = (prefeitura_id) => {
        setLoading(true);
        setor_api.GetList(prefeitura_id).then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao }
            });
            setRegionais(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }
    //Função que faz o controle do id da prefeitura e carrega as regionais
    const handlePrefeitura = (value) => {
        loadOptionsSetores(value);
    }
    useEffect(() => {
        loadOptionsPerfil();
    }, []);

    return (
        <div>
            {loading && <Loading />}
            <Row>
                <Col md={"12"} lg={"12"}>
                    <FiltroPrefeitura handleValue={handlePrefeitura} />
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        maxLength={"200"}
                        label={"* Nome"}
                        name="nome"
                        value={usuario.nome}
                        onChange={onChangeUsuario}
                        invalid={errors.nome ? true : false}
                    />
                    <PrintValidate field={"nome"} errors={errors} />
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        mask={mascaras.cpfcnpjMask}
                        maxLength={"18"}
                        label={"* CPF / CNPJ"}
                        name="cpfcnpj"
                        value={usuario.cpfcnpj}
                        onChange={onChangeUsuario}
                        onBlur={loadUsuarioByCPFCNPJ}
                        invalid={errors.cpfcnpj ? true : false}
                    />
                    <PrintValidate field={"cpfcnpj"} errors={errors} />
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        maxLength={"20"}
                        label={"* Status"}
                        type="select"
                        options={optionsStatus}
                        name="status"
                        value={usuario.status}
                        onChange={onChangeUsuario}
                        invalid={errors.status ? true : false}
                    />
                    <PrintValidate field={"status"} errors={errors} />
                </Col>
            </Row>
            <Row>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        maxLength={"100"}
                        label={"Cargo"}
                        name="cargo"
                        value={usuario.cargo}
                        onChange={onChangeUsuario}
                        invalid={errors.cargo ? true : false}
                    />
                    <PrintValidate field={"cargo"} errors={errors} />
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField mask={mascaras.celularMask}
                        maxLength={"14"} label={"Telefone"}
                        name="telefone"
                        value={usuario.telefone}
                        onChange={onChangeUsuario}
                        invalid={errors.telefone ? true : false}
                    />
                    <PrintValidate field={"telefone"} errors={errors} />
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        maxLength={"50"}
                        label={"Matrícula"}
                        name="matricula"
                        value={usuario.matricula}
                        onChange={onChangeUsuario}
                        invalid={errors.matricula ? true : false}
                    />
                    <PrintValidate field={"matricula"} errors={errors} />
                </Col>
            </Row>
            <Row>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        maxLength={"150"}
                        label={"* E-mail"}
                        name="email"
                        value={usuario.email}
                        onChange={onChangeUsuario}
                        invalid={errors.email ? true : false}
                    />
                    <PrintValidate field={"email"} errors={errors} />
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField maxLength={"30"}
                        label={"* Perfil"}
                        type="select"
                        options={optionsPerfil}
                        name="perfil"
                        value={usuario.perfil}
                        onChange={onChangeUsuario}
                        invalid={errors.perfil ? true : false}
                    />
                    <PrintValidate field={"perfil"} errors={errors} />
                </Col>
                {usuario.perfil == "Fiscal" &&
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            maxLength={"30"}
                            label={"Regionais"}
                            type="select"
                            options={regionais}
                            multiple
                            name="setores"
                            value={usuario.setores}
                            onChange={onChangeRegional}
                            invalid={errors.setores ? true : false}
                        />
                        <PrintValidate field={"setores"} errors={errors} />
                    </Col>
                }
            </Row>
        </div>
    )
}